import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { CodePostalDto, PaysDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-code-postal',
  templateUrl: './code-postal.component.html',
  styleUrls: ['./code-postal.component.css']
})
export class CodePostalComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.codesPostaux$) codesPostaux$: Observable<CodePostalDto[]>;
  
  @Input('codePostalId') public codePostalId: number;

  CodeInComponent: CodePostalDto;

  c: Subscription;
  
  constructor() {}

  ngOnInit() {
    this.c = this.codesPostaux$.subscribe(res => {
      if (res != null) {
        let codes = res.filter(c => c.Id == this.codePostalId);
        this.CodeInComponent = codes.length == 1 ? codes[0] : { Code: null, Localite: null };
      }
    });
  }

  ngOnDestroy() {
    this.c?.unsubscribe();
  }

}
